// extracted by mini-css-extract-plugin
module.exports = {"header__text":"video_header__text__1MUiQ","overlay":"video_overlay__10Qt_","modal":"video_modal__1Cjtk","close":"video_close__1CDFU"};